import { ScheduleAgeRange } from '@/types/patient-selection.types';

const boundOf = (value: number | null | undefined): number | undefined =>
  (typeof value === 'number' && value > 0 ? value : undefined);

const years = (age: number): string => (age === 1 ? '1 ano' : `${age} anos`);

export function isAgeWithinRange(age: number | undefined, range: ScheduleAgeRange): boolean {
  if (age === undefined) {
    return true;
  }

  const min = boundOf(range.minAge);
  const max = boundOf(range.maxAge);

  return (min === undefined || age >= min) && (max === undefined || age <= max);
}

export function formatAgeRange(range: ScheduleAgeRange): string {
  const min = boundOf(range.minAge);
  const max = boundOf(range.maxAge);

  if (min !== undefined && max !== undefined) {
    return `${min} a ${years(max)}`;
  }

  if (min !== undefined) {
    return `a partir de ${years(min)}`;
  }

  return max !== undefined ? `até ${years(max)}` : '';
}
